import { render } from "./DataExplorerLink.vue?vue&type=template&id=2db6fece&scoped=true"
import script from "./DataExplorerLink.vue?vue&type=script&lang=ts"
export * from "./DataExplorerLink.vue?vue&type=script&lang=ts"

import "./DataExplorerLink.vue?vue&type=style&index=0&id=2db6fece&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2db6fece"

export default script